document.addEventListener('DOMContentLoaded', function () {
  const openButtons = document.querySelectorAll('[data-event-popup-open]');

  openButtons.forEach(function (openBtn) {
    const popupId = openBtn.getAttribute('data-event-popup-open');
    const popup = document.querySelector('[data-event-popup="' + popupId + '"]');

    if (!popup) return;

    const closeBtn = popup.querySelector('.event-calendar-popup__close');
    const overlay = popup.querySelector('.event-calendar-popup__overlay');

    function openPopup() {
      popup.classList.add('is-active');
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closePopup() {
      popup.classList.remove('is-active');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    openBtn.addEventListener('click', openPopup);

    if (closeBtn) {
      closeBtn.addEventListener('click', closePopup);
    }

    if (overlay) {
      overlay.addEventListener('click', closePopup);
    }

    popup.addEventListener('click', function (event) {
      if (event.target === popup) {
        closePopup();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closePopup();
      }
    });
  });
});